<template>
  <Row class="h-100">
    <Col span="12" class="k4-logoContainer d-flex flex-column align-items-end flex-column h-100">
      <div class="my-auto">
          <div>
              <img src="../../assets/key4lead_logo_image_white_background.png" class="k4-logoContainer__logoImage mx-auto d-block"/>
          </div>
          <div class="my-4">
              <img src="../../assets/key4lead_logo_text_white.png" class="k4-logoContainer__logoText mx-auto d-block"/>
          </div>
      </div>
    </Col>

    <Col class="d-flex align-items-center justify-content-center h-100" span="12">
      <Form class="k4-loginContainer" ref="authForm" :model="authData" :rules="ruleInline" @keyup.enter.native="handleSubmit('authForm')">
        <p class="k4-loginContainer__welcome text-center">Welcome on <span class="k4-loginContainer__welcome__brandName font-weight-bold">KEY4LEAD</span></p>

        <Row>
          <i-col :xs="24" :sm="24" :md="24" :lg="24">
            <FormItem prop="Username">
              <i-input type="text" v-model="authData.Username" placeholder="Identification"
                      autocomplete="off" class="username-input">
              </i-input>
            </FormItem>
            <br>
          </i-col>
          <i-col :xs="24" :sm="24" :md="24" :lg="24">
            <FormItem prop="Password">
              <i-input type="password" v-model="authData.Password" placeholder="Password" autoComplete="off"
                      class="password-input">
                <Icon id="passIcon" type="ios-eye-off-outline" class="greenIcon" slot="append" size="28"/>
              </i-input>
            </FormItem>
            <br>
          </i-col>
          <i-col :xs="14" :sm="14" :md="14" :lg="14" align="left" valign="middle" class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="rememberMeCheckbox" v-model="rememberMe" @change="changeRememberMe">
            <label class="form-check-label" for="rememberMeCheckbox">Remember me</label>
          </i-col>
          <i-col :xs="24" :sm="24" :md="24" :lg="24" class="my-3">
            <FormItem>
              <Button type="submit" class="btn btn-success col-12" @click="handleSubmit('authForm')">
                  <span class="k4-loginContainer__loginButton__label text-white text-capitalize">Login</span>
              </Button>
            </FormItem>
          </i-col>
        </Row>
      </Form>
    </Col>
  </Row>
</template>

<script>
  import {login, setSession, removeSession} from '../../services/Authentication.service'
  import {getLoggedUser} from '../../services/User.service'
  import {getEvents} from '../../services/Events.service'
  import {getLicenses} from '../../services/Licenses.service'
  import {getCompanies, getCompanyById} from '../../services/Companies.service'
  import Router from '../../router';
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../../main'

  export default {
    data() {
        return {
            passwordShown: false,
            rememberMe: false,
            spinShow: false,
            activeName: "",
            admin: false,
            adminLogin: false,
            authData: {
                Username: "",
                Password: ""
            },
            ruleInline: {
                Username: [
                    { required: true, message: "Please fill in the user name", trigger: "blur" }
                ],
                Password: [
                    { required: true, message: "Please fill in the password.", trigger: "blur" },
                    { type: "string", min: 6, message: "The password length cannot be less than 6 characters", trigger: "blur" }
                ]
            }
        };
    },
    computed: {
        ...mapGetters(["getUserDetails", "getAdminUser"]),
        ...mapGetters(["getEvent", "getEventList"]),
        ...mapGetters(["getCompanyDetail", "getCompanyListDetail"]),
        ...mapGetters(["getLicenseDetail", "getLicenseListDetail"]),
    },
    methods: {
        ...mapActions(["setUserDetails", "setAdminUser"]),
        ...mapActions(["setEvent", "setEventList"]),
        ...mapActions(["setCompanyDetail", "setCompanyListDetail"]),
        ...mapActions(["setLicenseDetail", "setLicenseListDetail"]),
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    login(this.authData).then(response => {
                        setSession(response.data, this.authData.Username, "");
                        getLoggedUser(this.authData.Username)
                            .then(userObj => {
                            this.setUserDetails(userObj.data);
                            localStorage.setItem("fullName", userObj.data.firstName + " " + userObj.data.lastName);
                            this.fullName = localStorage.getItem("fullName");
                            if (userObj.data.userRoleId == 1) {
                                localStorage.setItem("role", "admin");
                            }
                            else {
                                if (userObj.data.userRoleId == 2) {
                                    localStorage.setItem("role", "manager");
                                }
                                else {
                                    localStorage.setItem("role", "user");
                                }
                            }
                            if (userObj.data.companyId) { //company logged in
                                localStorage.setItem("companyId", userObj.data.companyId);
                                getCompanyById(userObj.data.companyId).then(companiesObj => {
                                    let companies = [];
                                    companies.push({
                                        companyId: companiesObj.data.companyId,
                                        companyName: companiesObj.data.companyName,
                                        address: companiesObj.data.address,
                                        barcode: companiesObj.data.barcode,
                                        city: companiesObj.data.city,
                                        country: companiesObj.data.country,
                                        deleted: companiesObj.data.deleted,
                                        email: companiesObj.data.email,
                                        logoUrl: companiesObj.data.logoUrl,
                                        phone: companiesObj.data.phone,
                                        eventIds: companiesObj.data.eventIds,
                                        formIds: companiesObj.data.formIds,
                                        languageId: companiesObj.data.languageId,
                                        leadIds: companiesObj.data.leadIds,
                                        licenseIds: companiesObj.data.licenseIds,
                                    });
                                    localStorage.setItem("companies", JSON.stringify(companies));
                                    localStorage.setItem("selected_company", companies[0].companyId);
                                    sessionStorage.setItem("companyName", companies[0].companyName);
                                    this.setCompanyListDetail(companies);
                                    this.setCompanyDetail(companies[0]);
                                    this.userIcon = companiesObj.data.logoUrl;
                                    let events = [];
                                    let eventIds = companiesObj.data.eventIds;
                                    localStorage.setItem("eventIds", JSON.stringify(eventIds));
                                    getLicenses(false, userObj.data.companyId)
                                        .then(lic => {
                                        this.setLicenseListDetail(lic.data);
                                        getEvents(false).then(eventsObj => {
                                            eventsObj.data.map((evt) => {
                                                for (let i = 0; i < eventIds.length; ++i) {
                                                    if (eventIds[i] == evt.eventId) {
                                                        let returnData = {
                                                            eventName: evt.eventName,
                                                            eventId: evt.eventId,
                                                            startDate: evt.startDate,
                                                            endDate: evt.endDate,
                                                            location: evt.location,
                                                            iconUrl: evt.iconUrl,
                                                            bannerUrl: evt.bannerUrl,
                                                            participantForm: evt.participantForm,
                                                            deleted: evt.deleted,
                                                            companyIds: evt.companyIds
                                                        };
                                                        events.push(returnData);
                                                    }
                                                }
                                            });
                                            this.adminLogin = false;
                                            // localStorage.setItem('role', 'user');
                                            localStorage.setItem("events", JSON.stringify(events));
                                            localStorage.setItem("selected_event", events[0].eventId);
                                            this.setEvent(events[0]);
                                            this.setEventList(events);
                                            this.$emit("collectEventsData", events, companies);
                                            bus.$emit("reloadSideMenu", events, companies);
                                        })
                                            .catch(error => {
                                            console.log("Get Events Failed - LN 151 - " + error);
                                        });
                                    })
                                        .catch(error => {
                                          console.log("Get Licenses Failed - LN 164 - " + error);
                                    });
                                });
                            }
                            else { //super user logged in
                                //get all companies
                                getCompanies(false)
                                    .then(response => {
                                    let companies = [];
                                    response.data.map(item => {
                                        let returnData = {
                                            companyId: item.companyId,
                                            companyName: item.companyName,
                                            address: item.address,
                                            barcode: item.barcode,
                                            city: item.city,
                                            country: item.country,
                                            deleted: item.deleted,
                                            email: item.email,
                                            logoUrl: item.logoUrl,
                                            phone: item.phone,
                                            eventIds: item.eventIds,
                                            languageId: item.languageId
                                        };
                                        companies.push(returnData);
                                    });
                                    localStorage.setItem("companies", JSON.stringify(companies));
                                    localStorage.setItem("selected_company", companies[0].companyId);
                                    this.setCompanyDetail(companies[0]);
                                    this.setCompanyListDetail(companies);
                                    //get all events
                                    getEvents(false)
                                        .then(response => {
                                        let eventIds = [];
                                        let events = [];
                                        response.data.map((evt) => {
                                            let returnData = {
                                                eventName: evt.eventName,
                                                eventId: evt.eventId,
                                                startDate: evt.startDate,
                                                endDate: evt.endDate,
                                                location: evt.location,
                                                iconUrl: evt.iconUrl,
                                                bannerUrl: evt.bannerUrl,
                                                participantForm: evt.participantForm,
                                                deleted: evt.deleted,
                                                companyIds: evt.companyIds
                                            };
                                            events.push(returnData);
                                            eventIds.push(evt.eventId);
                                        });
                                        this.adminLogin = true;
                                        localStorage.setItem("role", "admin");
                                        localStorage.setItem("events", JSON.stringify(events));
                                        localStorage.setItem("eventIds", JSON.stringify(eventIds));
                                        localStorage.setItem("selected_event", events[0].eventId);
                                        this.setEvent(events[0]);
                                        this.setEventList(events);
                                        this.$emit("collectEventsData", events, companies);
                                        bus.$emit("reloadSideMenu", events, companies);
                                    })
                                        .catch(error => {
                                          console.log("Get Events Failed! - LN 227 - " + error);
                                    });
                                })
                                    .catch(error => {
                                      console.log("Get Companies Failed! - LN 231 - " + error);
                                });
                            }
                            //routing
                            if (!userObj.data.companyId) {
                                Router.push({ name: "GlobalAdministration" });
                            }
                            else {
  
                                Router.push({ name: "GeneralDashboard" });
                            }
                        })
                            .catch(error => {
                            this.$Message.error("Authentication Failed");
                            removeSession();
                            Router.push({ name: "Authentication" });
                        });
                    })
                        .catch(error => {
                        this.$Message.error("Login Failed");
                        removeSession();
                        Router.push({ name: "Authentication" });
                    });
                }
            });
        },
        changeRememberMe(e) {
            localStorage.setItem("rememberUser", this.rememberMe);
        },
        showPass(e) {
            e.target.className = "ivu-icon ivu-icon-ios-eye-outline redIcon";
            document.getElementsByTagName("input")[1].type = "text";
            this.passwordShown = true;
            return false;
        },
        hidePass(e) {
            e.target.className = "ivu-icon ivu-icon-ios-eye-off-outline greenIcon";
            document.getElementsByTagName("input")[1].type = "password";
            this.passwordShown = false;
            return false;
        },
    },
    created() {
        const self = this;
        setTimeout(function () {
            let ico = document.getElementById("passIcon");
            ico.addEventListener("mousedown", self.showPass);
            ico.addEventListener("mouseup", self.hidePass);
            ico.addEventListener("mouseout", self.hidePass);
        }, 300);
        if (localStorage.getItem("rememberUser") == "true") {
            this.rememberMe = true;
            this.authData.Username = localStorage.getItem("username");
        }
        else {
            this.rememberMe = false;
        }
        if (this.rememberMe == false) {
            this.authData.Username = "";
            this.authData.Password = "";
        }
    },
    mounted() {
        if (localStorage.getItem("rememberUser") == "true") {
            this.rememberMe = true;
            this.authData.Username = localStorage.getItem("username");
        }
        else {
            this.rememberMe = false;
        }
        if (this.rememberMe == false) {
            this.authData.Username = "";
            this.authData.Password = "";
        }
    }
}
</script>

<style scoped>
  .authentication-content {
    margin: auto auto;
    width: 350px;
    height: auto;
    padding: 5px;
    background-color: #fff;
    box-shadow: 0 0 10px #545454;
    border-radius: 5px;
    overflow: auto;
  }

  .login-image {
    height: 300px;
    width: 300px;
    background-image: url("../../../static/login_header.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
  }

  .login-submit {
    color: #fff;
    background: #244697;
    padding: 10px 28px;
    font-size: 14px;
    border: none;
  }

  .redIcon {
    color: #ea162c;
  }

  .greenIcon {
    color: #35bc44;
  }

  .k4-logoContainer {
    background: var(--primary);
    background: radial-gradient(circle, var(--primary) 0%, var(--primary-dark) 70%);
  }
  .k4-logoContainer {
    margin-top: auto;
    margin-bottom: auto;
  }
  .k4-logoContainer__logoImage {
    height: auto; 
    max-width: 25%;
  }
  .k4-logoContainer__logoText {
    height: auto; 
    max-width: 40%;
  }

  .k4-loginContainer {
    width: 70%;
  }
  .k4-loginContainer__welcome {
    font-size: 2em;
  }
  .k4-loginContainer__welcome__brandName {
    color: var(--success);
  }
  .k4-loginContainer__loginButton__label {
    font-size: 1.3em;
  }
</style>



// WEBPACK FOOTER //
// src/components/g_authentication/Authentication.vue